import { render } from "./softwareProduct.vue?vue&type=template&id=793fddae&scoped=true&ts=true"
import script from "./softwareProduct.vue?vue&type=script&lang=ts"
export * from "./softwareProduct.vue?vue&type=script&lang=ts"

import "./softwareProduct.vue?vue&type=style&index=0&id=793fddae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793fddae"]])

export default __exports__